import { useEffect, useState } from "react";
import { countries } from "../../../utils/config";
import { waitForCookie } from "../../../utils/helperFuctions";

const useCompanyLogic = () => {
  const initFields = [
    {
      name: "name",
      label: "Company Name",
      type: "text",
      isRequired: true,
      err: "Company Name is required",
    },

    {
      name: "country",
      label: "Country",
      type: "dropdown",
      isRequired: true,
      err: "Country is required",
      data: countries,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      isRequired: false,
      err: "Email is required",
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "phone",
      err: "Phone Number is required",
    },
    {
      name: "domain",
      label: "Domain",
      type: "text",
      isRequired: false,
      err: "Domain is required",
    },
    {
      name: "docs_link",
      label: "Files Link",
      type: "linkButton",
      isRequired: false,
    },

    {
      name: "vehicles",
      type: "companyVehicles",
      span: 5,
    },
    // Add more fields as needed
  ];
  const apiRoute = "companies";
  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const clientRole = process.env.REACT_APP_CLIENT_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, managerRole, financeRole];
  const deleteRoles = [admin, managerRole, financeRole];
  const editRoles = [admin, managerRole, financeRole, clientRole];
  const tabs = [
    {
      name: "Details",
      href: "#",
      current: true,
      fields: [
        "name",
        "country",
        "email",
        "phone",
        "domain",
        "docs_link",
      ],
      allowedRoles: [admin, managerRole, financeRole, clientRole],
    },
    {
      name: "Vehicles",
      href: "#",
      current: false,
      fields: ["vehicles"],
      allowedRoles: [admin, managerRole, financeRole, clientRole],
      hideNew: false,
    },
  ];
  const [tabsData, setTabsData] = useState([]);

  useEffect(() => {
    var interval = setInterval(async function () {
      const currentRole = await waitForCookie("_r");
      if (currentRole) {
        const __tabs = tabs.filter((x) => x.allowedRoles.includes(currentRole));
        if (__tabs?.length > 0) {
          __tabs[0].current = true;
        }
        setTabsData(__tabs);
        clearInterval(interval);
      }
    }, 100);

    return () => {
      setTabsData([]);
    };
  }, []);

  const getPromises = (temp) => {
    return [];
  };
  return {
    initFields,
    addRoles,
    deleteRoles,
    editRoles,
    getPromises,
    apiRoute,
    onlyform: undefined,
    tabs,
    tabsData,
  };
};

export default useCompanyLogic;
